import React from "react";

const map = {
  created: { label: "New", cls: "bg-gray-100 text-gray-700" },
  agreement_pending: { label: "Waiting for signatures", cls: "bg-amber-50 text-amber-700" },
  payment_pending: { label: "Deposit pending", cls: "bg-amber-50 text-amber-700" },
  active: { label: "Active", cls: "bg-emerald-50 text-emerald-700" },
  checkout_pending: { label: "Move-out pending", cls: "bg-amber-50 text-amber-700" },
  rating_phase1: { label: "Rating", cls: "bg-[#FFF4ED] text-indigo-700" },
  settlement_pending: { label: "Settling deposit", cls: "bg-[#FFF4ED] text-indigo-700" },
  dispute: { label: "In dispute", cls: "bg-red-50 text-red-700" },
  rating_phase2: { label: "Final rating", cls: "bg-[#FFF4ED] text-indigo-700" },
  completed: { label: "Completed", cls: "bg-emerald-50 text-emerald-700" },
  expired_continuing: { label: "Expired — Continuing", cls: "bg-amber-50 text-amber-800" },
  cancelled: { label: "Cancelled", cls: "bg-gray-100 text-gray-700" },
};

export default function StatusBadge({ status }) {
  const m = map[status] || { label: status, cls: "bg-gray-100 text-gray-700" };
  return <span className={`pill ${m.cls}`} data-testid={`status-${status}`}>{m.label}</span>;
}
